module.exports = new __parcel__URL__("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg").toString();